// Locks background scroll via position:fixed, not overflow:hidden — the latter turns
// <body> into a scroll container, which re-anchors the sticky page header to body's
// scrollport and drops it out of view (BL-798).
export const lockBodyScroll = () => {
  if (typeof document === 'undefined') return () => {};

  const documentElement = document.documentElement;
  const body = document.body;
  const scrollbarWidth = window.innerWidth - documentElement.clientWidth;
  const scrollY = window.scrollY;

  const originalStyles = {
    position: body.style.position,
    top: body.style.top,
    width: body.style.width,
    paddingRight: body.style.paddingRight,
  };

  // Prevents double-compensating: adding padding-right on top of globals.css's
  // reserved gutter would shift fixed elements the other way.
  const hasStableScrollbarGutter = window
    .getComputedStyle(documentElement)
    .getPropertyValue('scrollbar-gutter')
    .includes('stable');

  if (!hasStableScrollbarGutter && scrollbarWidth > 0) {
    body.style.paddingRight = `${scrollbarWidth}px`;
  }
  body.style.position = 'fixed';
  body.style.top = `-${scrollY}px`;
  body.style.width = '100%';

  return () => {
    body.style.position = originalStyles.position;
    body.style.top = originalStyles.top;
    body.style.width = originalStyles.width;
    body.style.paddingRight = originalStyles.paddingRight;
    // 'instant' avoids animating this restore under globals.css's scroll-behavior: smooth.
    window.scrollTo({ top: scrollY, left: 0, behavior: 'instant' });
  };
};
